export enum TaskPermissionType {
  /** im相关  */
  TaskImCreate = 'task-IM_CREATE',

  /** 竞标相关 */
  TaskModBid = 'task-MOD_BID', // 竞标中的任务发起变更或者编辑
  TaskBidTaskView = 'task-BID_TASK_VIEW', //查看竞标任务
  TaskConfirmProducer = 'task-CONFIRM_PRODUCER', // 确认制作方
  TaskCancelBid = 'task-CANCEL_BID', // 取消竞标

  /** 任务相关 */
  TaskUpdate = 'task-UPDATE', // 进行中的任务发起变更
  TaskReview = 'task-REVIEW', // 审核版本
  TaskModDirect = 'task-MOD_DIRECT', // 编辑任务基本信息
  TaskPassTask = 'task-PASS_TASK', // 通过任务
  TaskSettlement = 'task-SETTLEMENT', //发起/撤销结算
  TaskSettlementUpdate = 'task-SETTLEMENT_UPDATE', //同意/拒绝结算权限

  /** 制作方权限 */
  TaskSubmitVersion = 'task-SUBMIT_VERSION', // 提交版本

  /** 发布任务时权限 */
  AssignProducer = 'task-ASSIGN_PRODUCER', // 指派制作方
  AssignReviewer = 'task-ASSIGN_REVIEWER', // 指派审核方
  AssignDemander = 'task-ASSIGN_DEMANDER', // 指派需求方
  InviteCreator = 'task-INVITE_CREATOR', // 邀请制作方
}
